import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { MdClose } from 'react-icons/md';
import Feature from 'ol/Feature';
import StopEvents from '../stopevents/StopEvents';
import Button from '../button/Button';
import './Popup.scss';
var propTypes = {
  className: PropTypes.string,
  ContentComponent: PropTypes.func.isRequired,
  feature: PropTypes.instanceOf(Feature).isRequired,
  onCloseClick: PropTypes.func.isRequired,
  showCloseButton: PropTypes.bool.isRequired,
  store: PropTypes.shape(),
  t: PropTypes.func
};
var defaultProps = {
  className: '',
  store: null,
  t: function t(p) {
    return p;
  }
};

var Popup =
/*@__PURE__*/
function (PureComponent) {
  function Popup() {
    PureComponent.apply(this, arguments);
  }

  if (PureComponent) Popup.__proto__ = PureComponent;
  Popup.prototype = Object.create(PureComponent && PureComponent.prototype);
  Popup.prototype.constructor = Popup;

  Popup.prototype.render = function render() {
    var ref = this.props;
    var t = ref.t;
    var className = ref.className;
    var ContentComponent = ref.ContentComponent;
    var feature = ref.feature;
    var showCloseButton = ref.showCloseButton;
    var store = ref.store;
    var onCloseClick = ref.onCloseClick;
    var closeButton = null;

    if (showCloseButton) {
      closeButton = React.createElement(Button, {
        className: "tm-popup-close-button",
        title: "Popup " + t('Schliessen'),
        onClick: function onClick() {
          return onCloseClick();
        }
      }, React.createElement(MdClose, {
        focusable: false
      }));
    }

    return React.createElement('div', {
      className: "tm-popup " + className,
      role: "button",
      tabIndex: className === 'tm-tooltip' ? '0' : ''
    }, React.createElement(StopEvents, {
      observe: this,
      events: ['pointerdown', 'pointermove']
    }), closeButton, React.createElement(ContentComponent, {
      store: store,
      feature: feature
    }));
  };

  return Popup;
}(PureComponent);

Popup.propTypes = propTypes;
Popup.defaultProps = defaultProps;
export default Popup;